import { render, staticRenderFns } from "./OrderReturnItem.vue?vue&type=template&id=2d01b84b&scoped=true"
import script from "./OrderReturnItem.vue?vue&type=script&lang=ts"
export * from "./OrderReturnItem.vue?vue&type=script&lang=ts"
import style0 from "./OrderReturnItem.vue?vue&type=style&index=0&id=2d01b84b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01b84b",
  null
  
)

export default component.exports